// ═══════════════════════════════════════════════════════════════════════════════════════════════
// Did an extraction actually return values? Pure, unit-tested (src/__tests__/extraction-check.test.js).
//
// ⛔ A PARSED RESPONSE IS NOT A SUCCESSFUL EXTRACTION. On 2026-10-06 a 2023 LA County secured bill
// (8940-436-100) came back HTTP 200, valid JSON, bill type / due date / tax year filled — and every value and
// tax figure blank. The scanner showed "🤖 AI extracted" because the only test was "no error". A rescan of the
// same PDF was fine: the failure is intermittent, which is exactly why it has to be detected rather than
// prevented. This counts the figures the review actually needs and says when too few arrived.
// ═══════════════════════════════════════════════════════════════════════════════════════════════
import { moneyNum } from './money';

// The figures a review cannot do without, per document type. Zero counts as missing: a bill whose amount due,
// total tax and values are all $0 is the failure signature, not a real bill.
export const CORE_FIELDS = {
  taxbill: [
    ['market_value', 'market value'], ['taxable_value', 'taxable value'], ['total_ad_valorem', 'ad valorem total'],
    ['total_tax', 'total tax'], ['amount_due', 'amount due'],
  ],
};

// → { level: 'ok' | 'partial' | 'empty', present, total, missing: [labels] }
// empty   = none of the core figures arrived;
// partial = fewer than half arrived (the review would be mostly hand entry, so say so);
// ok      = half or more — individual gaps are visible on the form itself.
export function extractionCompleteness(fields, docType) {
  const core = CORE_FIELDS[docType];
  if (!core) return { level: 'ok', present: 0, total: 0, missing: [] };
  const missing = core.filter(([k]) => { const n = moneyNum(fields?.[k]); return n == null || n === 0; }).map(([, label]) => label);
  const total = core.length, present = total - missing.length;
  const level = present === 0 ? 'empty' : present < Math.ceil(total / 2) ? 'partial' : 'ok';
  return { level, present, total, missing };
}
